// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { collectionGroup, query, where, getDocs, getFirestore, collection } from "firebase/firestore";
import { doc, setDoc } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword, User } from 'firebase/auth';
import { ShopInfomation } from "../types/shop";
import { PaletteInformation } from "../types/palette";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAo34cAs0tIfLvyMXp16987ewtycW3q1ac",
  authDomain: "flower-quote.firebaseapp.com",
  projectId: "flower-quote",
  storageBucket: "flower-quote.appspot.com",
  messagingSenderId: "755222244851",
  appId: "1:755222244851:web:7a5a4db6c8f40a3f09f686",
  measurementId: "G-N6E9JBQVH9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth(app);
const db = getFirestore(app);

async function updateShop(user: User, shop: {shop: ShopInfomation, palettes: PaletteInformation[]}): Promise<void> {
    const data = {
        'ownerEmail': user.email,
        'ownerId': user.uid,
        shop: structuredClone(shop.shop),
        palettes: structuredClone(shop.palettes),
    }
    await setDoc(doc(db, "shops", data.shop.id), data);
}

async function signIn(email: string, password: string): Promise<boolean> {
    try {
        let userCreds = await signInWithEmailAndPassword(auth, email, password);
        console.log(userCreds.user.uid)
    } catch (error) {
        console.log(error);
        return false;
    }
    
    return true;
}

async function getShop(user: User): Promise<{shop: ShopInfomation, palettes: PaletteInformation[]}> {
    const shopsRef = collection(db, `shops`)
    const q = query(shopsRef, where("ownerId", "==", user.uid))
    const querySnapshot = await getDocs(q);
    let shopData: {shop: ShopInfomation, palettes: PaletteInformation[]} = {
        shop: {
            font: {
                fontUrl: "",
                fontFamily: ""
            },
            id: "",
            name: "",
            theme: {
                primaryColor: "#1976d2",
                secondaryColor: "#f50057"
            }
        },
        palettes: [
            {
                name: "general",
                id: "general",
                colors: [],
                products: [],
            }
        ],
    };
    querySnapshot.forEach((doc) => {
        shopData = {
            shop: doc.data().shop,
            palettes: doc.data().palettes
        };
    })
    // return a default shop that a new user an populate
    return shopData;
}

export { updateShop, getShop, auth, signIn}